module.exports = __webpack_public_path__ + "img/location.40c689b.png";